<template>
  <!--充值-->
  <div id="pay_id">
    <van-col span="24" class="pay_id">
      <van-col span="22" offset="1" class="my_peach_Recharge">
        <van-col span="24" class="my_peach_Recharge_coin">{{coin}}</van-col>
        <van-col span="24" class="my_peach_Recharge_name"> {{ coin_name }}{{ $t('other.balance') }}</van-col>
      </van-col>
      <!-- 支付类型  -->
      <van-col span="22" offset="1" class="pay_select">
        <span>チャージ</span>
        <van-col span="8" v-for="(top, i) in list" :key="top.id" class="pay_index_type_coin">
          <van-col span="24" :class="[styles == top.id ? 'pay_index_type_bors' :'pay_index_type_bor']" @click="top_money(i)">
            <van-col span="24" class="pay_index_type_coin_name">{{ is_ios ? top.ios_coin : top.coin }} {{ coin_name }}</van-col>
            <van-col span="24" class="my_peach_Recharge_money"> {{ is_ios ? top.ios_money : top.money }}{{ $t('other.yuan') }}</van-col>
            <van-col span="7" class="pay_index_type_coin_discount" v-if="top.discount">{{top.discount}}{{ $t('other.fracture') }}</van-col>
          </van-col>
        </van-col>
      </van-col>

      <van-col span="22" offset="1" class="pay_list_top">
        <van-radio-group v-model="isShow">
          <van-cell-group v-if="is_ios !== 1">
            <van-cell clickable v-for="pay in pay_list" :key="pay.id" @click="isShow = pay.id">
              <van-col span="5" class="pay_list_img"><img :src="pay.icon"/> </van-col>
              <van-col span="12" class="pay_list_pay_name">{{ pay.pay_name }}</van-col>
              <template #right-icon>
                <van-radio :name="pay.id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-col>

		  <van-col span="16" offset="4" class="pay_index_btns" >
        <van-button type="primary" size="large" class="my_peach_Recharge_btn" @click="top_sure" safe-area-inset-bottom>{{ $t('btn.Confirm_recharge') }}</van-button>
      </van-col>
      <van-col span="24" class="pay_index_sel" @click="agreement"><span>《{{ $t('other.User_recharge_protocol') }}》</span>{{ $t('other.Read_agree') }}</van-col>
      <van-overlay :show="is_loading" style="background-color: rgba(0,0,0,0.5);">
        <van-loading type="spinner" color="#ffffff" style="margin-top:50vh"/>
      </van-overlay>
    </van-col>
  </div>
</template>
<script src="https://unpkg.com/element-ui/lib/index.js"></script>
<script>
	//请求接口组件
  import '@/assets/css/index.css'
  import Toast from "vant/lib/toast"
  import { judgeIosAndroid } from '@/assets/js/models.js'
	import axios from 'axios'
  import {Overlay, Loading } from "vant";
	export default {
		name: 'Index',
		data:function() {
			return {
        is_loading: false,
				isShow: 0,
        is_ios: 0,
        is_ios_base: '0',
				coin:'',
        avatar:'',
        coin_name:'',
        list:[],
        pay_list:[],
				styles:'0',
        ios: '',
        google_pay: '',
        order_id: ''
			}
		},
		created: function() {
			this.convert();
			document.title = this.$t('title.index')
		},
    components: {
      [Overlay.name]: Overlay,
      [Loading.name]: Loading
    },
		methods: {
       // 充值列表
      top_money:function (i){
        this.styles= this.list[i].id
        this.ios= this.list[i].ios_product
        this.google_pay = this.list[i].google_pay
      },
      // 确认充值
      top_sure: function(){
        if(this.styles == 0){
          Toast(this.$t('Tips.Select_recharge_amount'))
          return false
        }
        if(this.isShow == 0){
          Toast(this.$t('Tips.Select_recharge_method'))
          return false
        }
        this.pay_Jump();
      },
      convert: function() {
          const uid = this.$route.query.uid;
          const token = this.$route.query.token;
         axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_wallet",{ params:{ uid:uid,token:token }}).then(res =>{
            console.log(res.data)
          this.list = res.data.data.list;
          this.pay_list = res.data.data.pay_list;
          if (this.pay_list.length > 0) {
            this.isShow = this.pay_list[0].id
          }
          this.is_ios = res.data.data.is_ios;
          this.is_ios_base = res.data.data.is_ios_base;
          this.coin = res.data.data.coin;
          this.avatar = res.data.data.avatar;
          this.coin_name = res.data.data.coin_name
          //console.log(res.data);
         })
       },
      // 充值 协议
      agreement:function(){
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        window.location.href='#/agreement?uid='+uid+'&token='+token + '&title=' + this.$t('other.User_recharge_protocol') + '&type=1';
      },
      pay_Jump (){
      //  this.is_loading = true
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          console.log("id="+this.styles+"&pay_type="+this.isShow+"&iappay="+this.ios)
          window.location.href="wallet://open_native?id="+this.styles+"&pay_type="+this.isShow+"&iappay="+this.ios
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.googlePay(this.styles,this.isShow,'1')
        }
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue